import React, { useState, useEffect, useRef } from 'react';
import { Truck } from 'lucide-react';

const API_BASE = process.env.REACT_APP_BACKEND_URL + '/api';

export const Logo = ({ size = 'default', className = '', variant = 'empresa' }) => {
  const [logoUrl, setLogoUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const objectUrlRef = useRef(null);

  const sizes = {
    small: { icon: 20, text: 'text-lg', height: 'h-8', imgHeight: 'h-8' },
    default: { icon: 28, text: 'text-2xl', height: 'h-10', imgHeight: 'h-10' },
    large: { icon: 36, text: 'text-3xl', height: 'h-14', imgHeight: 'h-12' }
  };

  const currentSize = sizes[size] || sizes.default;

  useEffect(() => {
    let isMounted = true;

    const loadLogo = async () => {
      try {
        const endpoint = variant === 'plataforma' 
          ? '/configuracion/logo-plataforma' 
          : '/configuracion/logo';
        
        const token = localStorage.getItem('token');
        const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
        
        // Use fetch instead of axios to avoid blob error handling issues
        const response = await fetch(`${API_BASE}${endpoint}`, { headers });
        
        if (response.ok && isMounted) {
          const blob = await response.blob();
          if (blob.size > 0) {
            if (objectUrlRef.current) {
              URL.revokeObjectURL(objectUrlRef.current);
            }
            const newUrl = URL.createObjectURL(blob);
            objectUrlRef.current = newUrl;
            setLogoUrl(newUrl);
          }
        }
      } catch (error) {
        // Silently fail - show default logo
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadLogo();

    return () => {
      isMounted = false;
      if (objectUrlRef.current) {
        URL.revokeObjectURL(objectUrlRef.current);
        objectUrlRef.current = null;
      }
    };
  }, [variant]);

  if (loading) {
    return (
      <div className={`flex items-center justify-center gap-2 animate-pulse ${className}`} data-testid="logo">
        <div className="bg-gray-200 rounded-md" style={{ width: currentSize.icon + 12, height: currentSize.icon + 12 }}></div>
        <div className="bg-gray-200 rounded h-6 w-32"></div>
      </div>
    );
  }

  if (logoUrl) {
    return (
      <div className={`flex items-center justify-center ${className}`} data-testid="logo">
        <img 
          src={logoUrl} 
          alt="Logo" 
          className={`${currentSize.imgHeight} object-contain max-w-full`}
          onError={() => {
            if (objectUrlRef.current) {
              URL.revokeObjectURL(objectUrlRef.current);
              objectUrlRef.current = null;
            }
            setLogoUrl(null);
          }}
        />
      </div>
    );
  }

  return (
    <div className={`flex items-center justify-center gap-2 ${className}`} data-testid="logo">
      <div className="bg-primary rounded-md p-1.5">
        <Truck size={currentSize.icon} className="text-white" strokeWidth={2.5} />
      </div>
      <span className={`font-bold ${currentSize.text} font-['Manrope'] tracking-tight text-primary`}>
        TRANS-LOGIC
      </span>
    </div>
  );
};
